module.exports = __webpack_public_path__ + "media/images/companies/teny-83b98757ac5fd2d5372bcd85760ffd69.jpg";